<h3 id="header" class="ui primary header">
			{{ modal.context.title }}
			<i class="link times icon" (click)="modal.deny(undefined)"></i>
		</h3>

		<div class="content">
			<div class="ui basic segment">
			<div fxLayout="row"  fxLayoutGap='15px' >
				<div fxFlex="20%">
					<select class="ui fluid dropdown" (change)="changeCondition($event)">
						<option *ngFor="let opt of groupOperators" [ngValue]="opt">{{opt.name}}</option>
					</select>
				</div>
				<div fxFlex="40%">
						<select class="ui fluid dropdown" [formControl]="selectForm" (ngModelChange)="logSelected($event)">
							<option *ngFor="let opt of headers" [ngValue]="opt">{{opt.label}}</option>
						</select>
				</div>
				<div fxFlex="20%">
				        <button class="ui  button" (click)="add()">
							<i class="plus circle icon"></i> Add Filter
						</button>
				</div>
			</div>

			<div class="ui form">
			<div fxLayout="row" *ngFor="let field of  fieldx; let i =index; trackBy:trackByIndex"  fxLayoutGap='15px' appMargin marginY="3">
			    <div fxFlex="30%">
                    <div class="field">
                        <input type="text" [(ngModel)]="fieldx[i].label" disabled/>
                    </div>
                </div>
                <div fxFlex="20%">
                    <div class="field">
                        <select *ngIf="field.field !== 'oldContractorUsername'" class="ui fluid dropdown" [(ngModel)]="fieldx[i].op" type="text"
                          >
                            <option *ngFor="let opt of operators" [ngValue]="opt.id">{{opt.name}}</option>
                        </select>
                        <select disabled *ngIf="field.field === 'oldContractorUsername'" class="ui fluid dropdown" [(ngModel)]="fieldx[i].op" type="text"
                            >
                            <option *ngFor="let opt of oldoperators" [ngValue]="opt.id">{{opt.name}}</option>
                        </select>
                    </div>
                </div>
                <div fxFlex="grow">
                    <app-search-number-filter *ngIf="field.type === 'integer'" [field]="fieldx[i]" [index]="i"></app-search-number-filter>
                    <app-search-text-filter *ngIf="field.type === 'text'" [field]="fieldx[i] " [index]="i"></app-search-text-filter>
                    <app-search-select-filter (query)="changeOperators($event)" *ngIf="field.type === 'select'" [field]="fieldx[i]" [index]="i"></app-search-select-filter>
                    <app-search-date-filter *ngIf="field.type === 'date'" [field]="fieldx[i] | dateTimeConverter" [index]="i"></app-search-date-filter>
                </div>
                <div fxFlex="15%">
                    <button class="ui red button icon" (click)="remove(i)">
                        <i class="minus icon"></i>
                    </button>
                </div>
			</div>
			</div>

			</div>
		</div>
<div class="actions text-right">
		  <button class="ui button" (click)="cancel()">Cancel</button>
			<button class="ui blue button" (click)="submit()">Apply Filter</button>
</div>